import React from 'react';
import { MachineType } from '../../stoerkID/StoerkIdAPI.model';
import { Group } from '../../groups/api/group.model';

/**
 * On Machine Type <MachineType>
 * find the channel name inside group.composableDevice.channels
 * if found use the index to find the label "channels.{index}.name" in machineType.labels
 * if not found return undefined
 *
 * @param machineType
 * @param filter
 * @returns channel name or undefined
 */
function getChannelNameByMachineType(
  group: Group | undefined,
  machineType: MachineType | undefined,
  filter: { channel?: string; controlUnitId?: string; deviceId?: string }
) {
  if (!group || !machineType || !group.composableDevice?.channels) {
    return undefined;
  }

  const channel = group.composableDevice.channels.find(
    (c) =>
      c.channel === filter.channel &&
      c.controlUnitId === filter.controlUnitId &&
      c.deviceId === filter.deviceId
  );
  if (channel) {
    const index = group.composableDevice.channels.indexOf(channel);
    return machineType.labels[`channels.${index}.name`];
  }

  return undefined;
}

export default getChannelNameByMachineType;
